import React from "react";
import { hooks } from "botframework-webchat-component";
import rammasIcon from "../../images/rammas_icon.gif";
const { useSendMessage } = hooks;

const WelcomeTiles = ({ isArabic, setIsThinking, loaded, basicConfig }) => {
  const { botName = "Rammas", title = "Powered by Generative AI", tiles, logoUrl } = basicConfig || {};
  // Move the hook inside the component
  const sendMessage = useSendMessage();
  // const arabicTitles = [
  //   {
  //     title: "الدفع السهل",
  //     subtitle: "أريد دفع فاتورتي باستخدام الدفع السهل",
  //     bgColor: "#007560",
  //     icon: "fa-credit-card",
  //     action: "Easy Pay",
  //   },
  //   {
  //     title: "الشاحن الأخضر EV",
  //     subtitle: "كيفية الحصول على البطاقة الخضراء EV؟",
  //     bgColor: "#0B7BC1",
  //     icon: "fa-question-circle",
  //     action: "Know more",
  //   },

  //   {
  //     title: "خدمة تشغيل الكهرباء/المياه",
  //     subtitle: "كيفية تفعيل الكهرباء والماء كمشترك جديد؟",
  //     bgColor: "#E26D5A",
  //     icon: "fa-question-circle",
  //     action: "Know more",
  //   },

  //   {
  //     title: "المقالات الرائجة",
  //     subtitle: "ما الجديد في هيئة كهرباء ومياه دبي؟",
  //     bgColor: "#6247AA",
  //     icon: "fa-newspaper",
  //     action: "Trending articles",
  //   },
  //   {
  //     title: "تتبع الطلبات",
  //     subtitle:"اريد تتبع حالة طلباتي",
  //     bgColor: "#FFD700",
  //     icon: "fa-tasks",
  //     action: "Track requests",
  //   },
  //   {
  //     title: "متجر ديوا",
  //     subtitle: "ما هي أحدث العروض؟",
  //     bgColor: "#FF6B6B",
  //     icon: "fa-store",
  //     action: "DEWA Store",
  //   },
  // ];

  // let tiles = [
  //   {
  //     title: "EasyPay",
  //     subtitle: "Pay my bill with EasyPay",
  //     bgColor: "#007560",
  //     icon: "fa-credit-card",
  //     action: "Easy Pay",
  //   },
  //   {
  //     title: "EV Green Charger",
  //     subtitle: "How to obtain an EV green card?",
  //     bgColor: "#0B7BC1",
  //     icon: "fa-question-circle",
  //     action: "Know more",
  //   },

  //   {
  //     title: "Move-in Service",
  //     subtitle: "How to activate electricity and water as new customer?",
  //     bgColor: "#E26D5A",
  //     icon: "fa-question-circle",
  //     action: "Know more",
  //   },
  //   {
  //     title: "Trending articles",
  //     subtitle: "What's new in DEWA?",
  //     bgColor: "#6247AA",
  //     icon: "fa-newspaper",
  //     action: "Trending articles",
  //   },
  //   {
  //     title: "Track requests",
  //     subtitle: "Track my requests status",
  //     bgColor: "#FFD700",
  //     icon: "fa-tasks",
  //     action: "Track requests",
  //   },
  //   {
  //     title: "DEWA Store",
  //     subtitle: "Check out DEWA Store",
  //     bgColor: "#FF6B6B",
  //     icon: "fa-store",
  //     action: "DEWA Store",
  //   },
  // ];
  // console.log("Checking for equal", isArabic);
  // if (isArabic) {
  //   tiles = arabicTitles;
  // }

  const isMobile = window.innerWidth <= 1000; // Check if the screen size is mobile

  const fontSize = isMobile ? "0.8rem" : "1.125rem"; // Adjust as needed
  const fontSizeLarge = isMobile ? "1rem" : "1.2rem"; // Adjust as needed

  return (
    <div style={{ padding: "20px", fontSize }}>
      <div
        style={{
          marginBottom: "20px",
          fontSize: "16px",
          textAlign: "center",
          display: "flex",
          flexDirection: "column",
          direction: isArabic ? "rtl" : "ltr",
          textAlign: isArabic ? "right" : "left",
          alignItems: "center",
        }}
      >
        <img src={logoUrl} alt="Rammas" style={{ width: "100px" }} />
        {}
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              textAlign: "center",
              fontSize: "28px", // Adjust the size as needed
              flexDirection: "column", // Stack the elements vertically
            }}
          >
            <span style={{ fontWeight: "bold" }}>{botName}</span>
            <span style={{
              color: "6f6f6f", fontSize: "16px", // Adjust the size as needed
            }}>{title}</span>
          </div>
      </div>
      <div
        style={{
          display: "flex",
          flexWrap: isMobile ? "nowrap" : "wrap",
          flexDirection: isMobile ? "column" : "row", // Use column layout for mobile
          gap: "10px",
          justifyContent: "space-between",
        }}
      >
        {tiles && tiles.map((tile) => (
          <div
            key={tile.title}
            onClick={() => {
              if (!loaded) {
                setIsThinking(true);

                sendMessage(tile.subtitle, undefined, {
                  channelData: {
                    role: "user",
                  },
                });
              }
            }}
            style={{
              backgroundColor: "#fff",
              color: "#222222",
              boxShadow: "0px 3px 8px -1px #3232470D",
              padding: "15px",
              borderRadius: "8px",
              cursor: "pointer",
              flex: isMobile ? "1 0 100%" : "0 0 calc(33.33% - 10px)",
              display: "flex",
              flexDirection: "column",
              boxShadow: "1px 1px 5px 1px #D3D3D3",
              height: isMobile ? "auto" : "150px",
              direction: isArabic ? "rtl" : "ltr",
              textAlign: isArabic ? "rtl" : "ltr",
              justifyContent: "center",
              alignItems: isArabic ? "flex-start" : "flex-end",
              marginBottom: "10px",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: isMobile ? "row" : "column", // Row for mobile, column for desktop
                alignItems: isMobile ? "center" : "flex-start", // Center vertically in row mode
                width: "100%",
              }}
            >
              <span
                style={{
                  marginBottom: isMobile ? 0 : "10px",
                  marginRight: isMobile ? (isArabic ? 0 : "10px") : 0,
                  marginLeft: isMobile ? (isArabic ? "10px" : 0) : 0,
                }}
              >
                <span className="fa-stack">
                  <i
                    className="fas fa-circle fa-stack-2x"
                    style={{ color: tile.bgColor }}
                  ></i>
                  <i
                    className={`fas ${tile.icon} fa-stack-1x`}
                    style={{ color: "#fff" }}
                  ></i>
                </span>
              </span>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  // alignItems: isArabic ? "flex-end" : "flex-start",
                  // direction: isArabic ? "rtl" : "ltr",
                }}
              >
                <h4
                  style={{
                    margin: 0,
                    fontWeight: 600,
                    fontSize: isMobile ? "14px" : "18px",
                    // textAlign: isArabic ? "right" : "left",
                  }}
                >
                  {tile.title}
                </h4>
                {!isMobile && (
                  <p
                    style={{
                      margin: "5px 0 0 0",
                      fontSize: "14px",
                      // textAlign: isArabic ? "right" : "left",
                    }}
                  >
                    {tile.subtitle}
                  </p>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WelcomeTiles;
